import React, { Component } from "react";
import FlexView from "react-flexview";
import Button from "../../../modules/commons/Button";
import moment from "moment";
import { NOT_COMPLETE_TAB, TAB_CODE } from "./constant";
import { ACTIVITY_TYPE } from "../../common/Constants";
import { removeNullFields } from "../../common/mapper";

export const getTableColumns = ({
  tab,
  onShowDetail,
  dataTable,
  userAccess,
}) => [
  {
    name: "",
    label: "No",
    options: {
      customBodyRender: (_, tableMeta) => {
        const { page, rowsPerPage } = tableMeta.tableState;
        return page * rowsPerPage + tableMeta.rowIndex + 1;
      },
      setCellProps: () => ({
        style: { width: "5%" },
      }),
    },
  },
  {
    name: "idClaim",
    label: "ID Claim",
    options: {
      sort: false,
    },
  },
  {
    name: "tanggalClaim",
    label: "Tanggal Claim",
    options: {
      sort: false,
    },
  },
  {
    name: "tipeClaim",
    label: "Tipe Claim",
    options: {
      sort: false,
    },
  },
  {
    name: "nomorClaim",
    label: "Nomor Claim",
    options: {
      sort: false,
    },
  },
  {
    name: "namaPelapor",
    label: "Nama Pelapor",
    options: {
      sort: false,
    },
  },

  {
    name: "namaPemilik",
    label: "Nama Pemilik",
    options: {
      sort: false,
    },
  },
  {
    name: "kodeVarian",
    label: "Kode Varian",
    options: {
      sort: false,
    },
  },
  {
    name: "namaVarian",
    label: "Nama Varian",
    options: {
      sort: false,
    },
  },
  {
    name: "kodeWarna",
    label: "Kode Warna",
    options: {
      sort: false,
    },
  },
  {
    name: "namaWarna",
    label: "Nama Warna",
    options: {
      sort: false,
    },
  },

  {
    name: "nomorRangka",
    label: "Nomor Rangka",
    options: {
      sort: false,
    },
  },
  {
    name: "nomorMesin",
    label: "Nomor Mesin",
    options: {
      sort: false,
    },
  },
  {
    name: "umurDays",
    label: "Umur (Days)",
    options: {
      sort: false,
    },
  },
  {
    name: "tanggalLengkap",
    label: "Tanggal Lengkap",
    options: {
      sort: false,
      display: tab === TAB_CODE.LENGKAP,
    },
  },
  {
    name: "id",
    label: "Aksi",
    options: {
      sort: false,
      customBodyRender: (val, { rowIndex }) => {
        //can delete if data exist on belum lengkap & belum pencairan
        const canDelete = dataTable[rowIndex]?.canDelete;
        return (
          <FlexView style={{ gap: "15px" }}>
            {NOT_COMPLETE_TAB.includes(tab) && userAccess?.createAccess && (
              <ButtonAction
                iconName="fa-paper-plane"
                onClick={() => onShowDetail(ACTIVITY_TYPE.VIEW, val)}
              />
            )}
            {userAccess?.updateAccess && (
              <ButtonAction
                iconName="fa-pencil-alt"
                onClick={() =>
                  onShowDetail(ACTIVITY_TYPE.UPDATE, val, !canDelete)
                }
              />
            )}
            {NOT_COMPLETE_TAB.includes(tab) && userAccess?.deleteAccess && (
              <ButtonAction
                disable={!canDelete}
                iconName="fa-trash"
                onClick={() => {
                  if (!canDelete) {
                    return;
                  }
                  onShowDetail(ACTIVITY_TYPE.DELETE, val);
                }}
              />
            )}
          </FlexView>
        );
      },
    },
  },
];

class ButtonAction extends Component {
  render() {
    const { iconName, onClick, ...rest } = this.props;
    return (
      <Button
        {...rest}
        className="btnAct background-transparent txt-site txt-title"
        type="button"
        onClick={onClick}
      >
        <i
          className={`fa ${iconName} ${
            rest.disable ? "color-grey" : "color-red"
          }`}
        />
      </Button>
    );
  }
}

export const formGroupManagementClaim = {
  id: { value: null },
  idClaim: { value: null },
  tanggalClaim: { value: moment().format("DD-MM-YYYY") },
  nomorClaim: { value: null, mandatory: true },
  tipePengajuan: { value: null, mandatory: true },
  noBBM: { value: null },
  idHotline: { value: null },
  nomorPembelian: { value: null },
  isNonHotline: { value: false },
  tahunProduksi: { value: null, mandatory: true },
  namaPelapor: { value: null, mandatory: true },
  nomorRangka: { value: null, mandatory: true },
  nomorMesin: { value: null, mandatory: true },
  kodeWarna: { value: null, mandatory: true },
  namaWarna: { value: null, mandatory: true },
  kodeVarian: { value: null, mandatory: true },
  namaVarian: { value: null, mandatory: true },

  namaPemilik: { value: null, mandatory: true },
  nik: { value: null },
  alamat: { value: null },
  province: { value: null, mandatory: true },
  kabkot: { value: null, mandatory: true },
  kecamatan: { value: null, mandatory: true },
  kelurahan: { value: null, mandatory: true },
  zipcode: { value: null, mandatory: true },
  memberId: { value: null },
  nomorHp1: { value: null, mandatory: true },
  nomorHp2: { value: null },
};

export const constructDataFilter = (data) => {
  return removeNullFields({
    ...data,
    tipeClaim: data?.tipeClaim?.value || null,
    nonHotline:
      data?.nonHotline?.value !== undefined ? data?.nonHotline?.value : null,
    kodeVarian: data?.kodeVarian?.value || null,
    kodeWarna: data?.kodeWarna?.value || null,
    provinsi: data?.provinsi?.value || null,
    kabkot: data?.kabkot?.value || null,
    kecamatan: data?.kecamatan?.value || null,
    kelurahan: data?.kelurahan?.value || null,
    kodePos: data?.kodePos?.value || null,
    kodePart: data?.kodePart?.value || null,
  });
};
